
// import React from 'react';
// import Idcard from './Idcard';
// import './index.css'; // Assuming you have a CSS file for styles
// function App() {
//     return (
//         <div style={styles.container}>
//             <div style={styles.content}>
//             <h1 className="text-red-800 text-lowercase">Student ID Card</h1>
//             <Idcard
//                 name="Punam Nepali"
//                 college="PMC"
//                 semester="Seventh"
//                 studentid="45"
//                 profileimage="/image/A1.avif"
//             />
//             </div>
//         </div>
//     );
// }

// const styles = {
//     container: {
//         height: '100vh',
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         backgroundColor: '#f0f0f0',
//     },
//     content: {
//         textAlign: 'center',
//     },
// };

// export default App;


import React from 'react';
import Idcard from './Idcard';
import './index.css'; // Assuming you have a CSS file for styles
function App() {
    return (
        <div className="flex items-center justify-center ">
         
            <Idcard
                name="Punam Nepali"
                DOB="2003-09-26"
                Address="Bagbazaar,Kathmandu"
                college="PKMC"
                semester="Seventh"
                studentid="45"
                profileimage="/image/A1.avif"
                Validity="2025-2026"
            />
            
            </div>
            
    );
}

export default App;